// @ts-expect-error this library does not have TS version?
import createHistory from 'history/lib/createHashHistory';

export const history = createHistory({ queryKey: false });

export const triggers = {
  pushNext: false,
};
